import React, { useState } from "react";
import { Route, Switch } from "react-router";
import styled from "styled-components";
import Home from "./pages/Home";
import Incentives from "./pages/Incentives";
import Protocol from "./pages/Protocol";
import Governance from "./pages/Governance";
import Information from './pages/Information'
import DeFi from './pages/DeFi'
import Web from './pages/Web'
import People from './pages/People'
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
    const [menu, setMenu] = useState(false);

    return (
      <Div className='App' hide={menu}>
          <Header menu={menu} setMenu={setMenu} />
          <Switch>
              <Route path='/' exact component={Home} />
              <Route path='/incentives' component={Incentives} />
              <Route path='/protocol' component={Protocol} />
              <Route path='/defi' component={DeFi} />
              <Route path='/information' component={Information} />
              <Route path='/technology' component={Web} />
              <Route path='/people' component={People} />
              <Route path='/governance' component={Governance} />
              {/* <Route path="*" component={Home} /> */}
          </Switch>
          <Footer />
      </Div>
  );
}

const Div = styled.div`
    height: ${(props) => (props.hide ? "100vh" : "auto")};
    overflow-y: ${(props) => (props.hide ? "hidden" : "auto")};
    /* margin-top: ${props => (props.hide ? '0px' : '100px')}; */
    margin-top: 100px;

    @media screen and (max-width: 650px) {
        /* margin-top: ${props => (props.hide ? '0px' : '75px')}; */
        margin-top: 75px;
    }
`;

export default App;
